import { Component, Input, OnInit } from "@angular/core";
import { MultiHouseCalendarService } from "../../calendar/multi-house-calendar/multi-house-calendar.service";
import { NzDrawerRef } from "ng-zorro-antd/drawer";

@Component({
  selector: "host-operate-hour-reservation-sidebar",
  templateUrl: "./hour-reservation-sidebar.component.html",
  styleUrls: ["./hour-reservation-sidebar.component.scss"],
})
export class HourReservationSidebarComponent implements OnInit {
  @Input() data;
  index = 0;
  constructor(
    private calendarSrv: MultiHouseCalendarService,
    private drawerRef: NzDrawerRef,
  ) {}

  ngOnInit() {}

  onClickCancel() {
    this.calendarSrv.cancelSelect();

    this.drawerRef?.close();
  }
}
